import { addSideEffects, initAction } from '@poa/state';
import {
  reportsAvailablePresets,
  reportsLastSelectedPreset
} from '../reports/reports.side-effects';
import { clone } from '../shared/clone';
import {
  changeColumnPreset,
  deleteById,
  deletePreset,
  fetch,
  fetchById,
  getInfoById,
  getАссоuntInfoById,
  saveColumnPreset
} from './report-archives.actions';

addSideEffects(fetch, async (_, { actions, env }) => {
  try {
    const data = await env.api.reportArchives.fetch();

    actions.reportArchivesActions.fetchSuccess(data);
  } catch (e) {
    console.error(e);
    actions.reportArchivesActions.fetchFailed();
    throw e;
  }
});

addSideEffects(fetchById, async (payload, { actions, env, router }) => {
  try {
    // fetch statuses
    const reportsStatuses = await env.api.reports.fetchReportsStatuses();
    actions.reportArchivesActions.resetStatuses(reportsStatuses);

    // fetch sorting
    const reportsGrouping = await env.api.reports.fetchReportsGrouping();
    actions.reportArchivesActions.resetGrouping(reportsGrouping);

    const data = await env.api.reportArchives.fetchById(payload.id);

    actions.reportArchivesActions.fetchByIdSuccess(data);
  } catch (e) {
    console.error(e);
    actions.reportArchivesActions.fetchByIdFailed();
    throw e;
  }
});

addSideEffects(deleteById, async ({ id }, { env }) => {
  try {
    await env.api.reportArchives.deleteById(id);
  } catch (e) {
    env.alert('Error', 'Удаление архива провалилось', 'error');
  }
});

addSideEffects(getInfoById, async ({ id }, { env }) => {
  try {
    await env.api.reportArchives.getInfoById(id);
  } catch (e) {
    env.alert('Error', 'Реквизиты вам никто не даст', 'error');
  }
});

addSideEffects(getАссоuntInfoById, async ({ id }, { env }) => {
  try {
    await env.api.reportArchives.getАссоuntInfoById(id);
  } catch (e) {
    env.alert('Error', 'Реквизиты вам никто не даст', 'error');
  }
});

// persist settings
addSideEffects(saveColumnPreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.reportArchives.filters.columnSettings;

  await env.storage.setItem(reportsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

addSideEffects(deletePreset, async (_, { env, store }) => {
  const { availablePresets, currentPresetId } = store.reportArchives.filters.columnSettings;

  await env.storage.setItem(reportsAvailablePresets, clone(availablePresets));
  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

addSideEffects(changeColumnPreset, async (_, { env, store }) => {
  const { currentPresetId } = store.reportArchives.filters.columnSettings;

  await env.storage.setItem(reportsLastSelectedPreset, currentPresetId);
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const availablePresets = await env.storage.getItem(reportsAvailablePresets);
  const presetId = await env.storage.getItem(reportsLastSelectedPreset);

  if (availablePresets && presetId) {
    actions.reportArchivesActions.resetColumnSettings({ presetId, availablePresets });
    return;
  }

  if (availablePresets) {
    actions.reportArchivesActions.resetColumnSettings({
      presetId: availablePresets[0].id, // default one
      availablePresets
    });
    return;
  }

  actions.reportArchivesActions.resetColumnSettings({
    presetId: store.reportArchives.filters.columnSettings.availablePresets[0].id, // default one
    availablePresets: store.reportArchives.filters.columnSettings.availablePresets
  });
});
